import React from "react";
import { PortalDetailedActivityLoaderTemplate } from "themes/administration/analytics/components";

function PortalDetailedActivityLoader(props) {
    return <PortalDetailedActivityLoaderTemplate {...props} />;
}

export default PortalDetailedActivityLoader;
